// extracted by mini-css-extract-plugin
export default {"QuickEditModal":"QuickEditModal_QuickEditModal__Gv98G","ToggleButtonContainer":"QuickEditModal_ToggleButtonContainer__Mpd7e"};